/* eslint-disable */
// Generated by scripts/build-validators.mjs from the schemas in
// src/js/validation-schema-defs.js: AJV's own checks, written ahead of time
// so the page compiles no code at run time. Do not edit this file; run
// node scripts/build-validators.mjs after changing a schema.
import * as ucs2Module from 'ajv/dist/runtime/ucs2length.js';
const ucs2length =
  ucs2Module.default?.default ?? ucs2Module.default ?? ucs2Module;
export const validateFileUpload = validate10;
const schema11 = {
  type: 'object',
  required: ['name', 'size'],
  properties: {
    name: { type: 'string', minLength: 1 },
    size: { type: 'number', minimum: 0 },
  },
  anyOf: [
    {
      properties: {
        name: { type: 'string', pattern: '\\.scad$' },
        size: { type: 'number', maximum: 5242880 },
      },
    },
    {
      properties: {
        name: { type: 'string', pattern: '\\.zip$' },
        size: { type: 'number', maximum: 262144000 },
      },
    },
  ],
};
const pattern0 = new RegExp('\\.scad$', 'u');
const pattern1 = new RegExp('\\.zip$', 'u');
const func2 = ucs2length;
function validate10(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data } = {}
) {
  let vErrors = null;
  let errors = 0;
  const _errs1 = errors;
  let valid0 = false;
  const _errs2 = errors;
  if (data && typeof data == 'object' && !Array.isArray(data)) {
    if (data.name !== undefined) {
      let data0 = data.name;
      if (typeof data0 !== 'string') {
        let dataType0 = typeof data0;
        let coerced0 = undefined;
        if (!(coerced0 !== undefined)) {
          if (dataType0 == 'number' || dataType0 == 'boolean') {
            coerced0 = '' + data0;
          } else if (data0 === null) {
            coerced0 = '';
          } else {
            const err0 = {
              instancePath: instancePath + '/name',
              schemaPath: '#/anyOf/0/properties/name/type',
              keyword: 'type',
              params: { type: 'string' },
              message: 'must be string',
            };
            if (vErrors === null) {
              vErrors = [err0];
            } else {
              vErrors.push(err0);
            }
            errors++;
          }
        }
        if (coerced0 !== undefined) {
          data0 = coerced0;
          if (data !== undefined) {
            data['name'] = coerced0;
          }
        }
      }
      if (typeof data0 === 'string') {
        if (!pattern0.test(data0)) {
          const err1 = {
            instancePath: instancePath + '/name',
            schemaPath: '#/anyOf/0/properties/name/pattern',
            keyword: 'pattern',
            params: { pattern: '\\.scad$' },
            message: 'must match pattern "' + '\\.scad$' + '"',
          };
          if (vErrors === null) {
            vErrors = [err1];
          } else {
            vErrors.push(err1);
          }
          errors++;
        }
      }
    }
    if (data.size !== undefined) {
      let data1 = data.size;
      if (!(typeof data1 == 'number' && isFinite(data1))) {
        let dataType1 = typeof data1;
        let coerced1 = undefined;
        if (!(coerced1 !== undefined)) {
          if (
            dataType1 == 'boolean' ||
            data1 === null ||
            (dataType1 == 'string' && data1 && data1 == +data1)
          ) {
            coerced1 = +data1;
          } else {
            const err2 = {
              instancePath: instancePath + '/size',
              schemaPath: '#/anyOf/0/properties/size/type',
              keyword: 'type',
              params: { type: 'number' },
              message: 'must be number',
            };
            if (vErrors === null) {
              vErrors = [err2];
            } else {
              vErrors.push(err2);
            }
            errors++;
          }
        }
        if (coerced1 !== undefined) {
          data1 = coerced1;
          if (data !== undefined) {
            data['size'] = coerced1;
          }
        }
      }
      if (typeof data1 == 'number' && isFinite(data1)) {
        if (data1 > 5242880 || isNaN(data1)) {
          const err3 = {
            instancePath: instancePath + '/size',
            schemaPath: '#/anyOf/0/properties/size/maximum',
            keyword: 'maximum',
            params: { comparison: '<=', limit: 5242880 },
            message: 'must be <= 5242880',
          };
          if (vErrors === null) {
            vErrors = [err3];
          } else {
            vErrors.push(err3);
          }
          errors++;
        }
      }
    }
  }
  var _valid0 = _errs2 === errors;
  valid0 = valid0 || _valid0;
  if (!valid0) {
    const _errs7 = errors;
    if (data && typeof data == 'object' && !Array.isArray(data)) {
      if (data.name !== undefined) {
        let data2 = data.name;
        if (typeof data2 !== 'string') {
          let dataType2 = typeof data2;
          let coerced2 = undefined;
          if (!(coerced2 !== undefined)) {
            if (dataType2 == 'number' || dataType2 == 'boolean') {
              coerced2 = '' + data2;
            } else if (data2 === null) {
              coerced2 = '';
            } else {
              const err4 = {
                instancePath: instancePath + '/name',
                schemaPath: '#/anyOf/1/properties/name/type',
                keyword: 'type',
                params: { type: 'string' },
                message: 'must be string',
              };
              if (vErrors === null) {
                vErrors = [err4];
              } else {
                vErrors.push(err4);
              }
              errors++;
            }
          }
          if (coerced2 !== undefined) {
            data2 = coerced2;
            if (data !== undefined) {
              data['name'] = coerced2;
            }
          }
        }
        if (typeof data2 === 'string') {
          if (!pattern1.test(data2)) {
            const err5 = {
              instancePath: instancePath + '/name',
              schemaPath: '#/anyOf/1/properties/name/pattern',
              keyword: 'pattern',
              params: { pattern: '\\.zip$' },
              message: 'must match pattern "' + '\\.zip$' + '"',
            };
            if (vErrors === null) {
              vErrors = [err5];
            } else {
              vErrors.push(err5);
            }
            errors++;
          }
        }
      }
      if (data.size !== undefined) {
        let data3 = data.size;
        if (!(typeof data3 == 'number' && isFinite(data3))) {
          let dataType3 = typeof data3;
          let coerced3 = undefined;
          if (!(coerced3 !== undefined)) {
            if (
              dataType3 == 'boolean' ||
              data3 === null ||
              (dataType3 == 'string' && data3 && data3 == +data3)
            ) {
              coerced3 = +data3;
            } else {
              const err6 = {
                instancePath: instancePath + '/size',
                schemaPath: '#/anyOf/1/properties/size/type',
                keyword: 'type',
                params: { type: 'number' },
                message: 'must be number',
              };
              if (vErrors === null) {
                vErrors = [err6];
              } else {
                vErrors.push(err6);
              }
              errors++;
            }
          }
          if (coerced3 !== undefined) {
            data3 = coerced3;
            if (data !== undefined) {
              data['size'] = coerced3;
            }
          }
        }
        if (typeof data3 == 'number' && isFinite(data3)) {
          if (data3 > 262144000 || isNaN(data3)) {
            const err7 = {
              instancePath: instancePath + '/size',
              schemaPath: '#/anyOf/1/properties/size/maximum',
              keyword: 'maximum',
              params: { comparison: '<=', limit: 262144000 },
              message: 'must be <= 262144000',
            };
            if (vErrors === null) {
              vErrors = [err7];
            } else {
              vErrors.push(err7);
            }
            errors++;
          }
        }
      }
    }
    var _valid0 = _errs7 === errors;
    valid0 = valid0 || _valid0;
  }
  if (!valid0) {
    const err8 = {
      instancePath,
      schemaPath: '#/anyOf',
      keyword: 'anyOf',
      params: {},
      message: 'must match a schema in anyOf',
    };
    if (vErrors === null) {
      vErrors = [err8];
    } else {
      vErrors.push(err8);
    }
    errors++;
  } else {
    errors = _errs1;
    if (vErrors !== null) {
      if (_errs1) {
        vErrors.length = _errs1;
      } else {
        vErrors = null;
      }
    }
  }
  if (data && typeof data == 'object' && !Array.isArray(data)) {
    if (data.name === undefined) {
      const err9 = {
        instancePath,
        schemaPath: '#/required',
        keyword: 'required',
        params: { missingProperty: 'name' },
        message: "must have required property '" + 'name' + "'",
      };
      if (vErrors === null) {
        vErrors = [err9];
      } else {
        vErrors.push(err9);
      }
      errors++;
    }
    if (data.size === undefined) {
      const err10 = {
        instancePath,
        schemaPath: '#/required',
        keyword: 'required',
        params: { missingProperty: 'size' },
        message: "must have required property '" + 'size' + "'",
      };
      if (vErrors === null) {
        vErrors = [err10];
      } else {
        vErrors.push(err10);
      }
      errors++;
    }
    if (data.name !== undefined) {
      let data4 = data.name;
      if (typeof data4 !== 'string') {
        let dataType4 = typeof data4;
        let coerced4 = undefined;
        if (!(coerced4 !== undefined)) {
          if (dataType4 == 'number' || dataType4 == 'boolean') {
            coerced4 = '' + data4;
          } else if (data4 === null) {
            coerced4 = '';
          } else {
            const err11 = {
              instancePath: instancePath + '/name',
              schemaPath: '#/properties/name/type',
              keyword: 'type',
              params: { type: 'string' },
              message: 'must be string',
            };
            if (vErrors === null) {
              vErrors = [err11];
            } else {
              vErrors.push(err11);
            }
            errors++;
          }
        }
        if (coerced4 !== undefined) {
          data4 = coerced4;
          if (data !== undefined) {
            data['name'] = coerced4;
          }
        }
      }
      if (typeof data4 === 'string') {
        if (func2(data4) < 1) {
          const err12 = {
            instancePath: instancePath + '/name',
            schemaPath: '#/properties/name/minLength',
            keyword: 'minLength',
            params: { limit: 1 },
            message: 'must NOT have fewer than 1 characters',
          };
          if (vErrors === null) {
            vErrors = [err12];
          } else {
            vErrors.push(err12);
          }
          errors++;
        }
      }
    }
    if (data.size !== undefined) {
      let data5 = data.size;
      if (!(typeof data5 == 'number' && isFinite(data5))) {
        let dataType5 = typeof data5;
        let coerced5 = undefined;
        if (!(coerced5 !== undefined)) {
          if (
            dataType5 == 'boolean' ||
            data5 === null ||
            (dataType5 == 'string' && data5 && data5 == +data5)
          ) {
            coerced5 = +data5;
          } else {
            const err13 = {
              instancePath: instancePath + '/size',
              schemaPath: '#/properties/size/type',
              keyword: 'type',
              params: { type: 'number' },
              message: 'must be number',
            };
            if (vErrors === null) {
              vErrors = [err13];
            } else {
              vErrors.push(err13);
            }
            errors++;
          }
        }
        if (coerced5 !== undefined) {
          data5 = coerced5;
          if (data !== undefined) {
            data['size'] = coerced5;
          }
        }
      }
      if (typeof data5 == 'number' && isFinite(data5)) {
        if (data5 < 0 || isNaN(data5)) {
          const err14 = {
            instancePath: instancePath + '/size',
            schemaPath: '#/properties/size/minimum',
            keyword: 'minimum',
            params: { comparison: '>=', limit: 0 },
            message: 'must be >= 0',
          };
          if (vErrors === null) {
            vErrors = [err14];
          } else {
            vErrors.push(err14);
          }
          errors++;
        }
      }
    }
  } else {
    const err15 = {
      instancePath,
      schemaPath: '#/type',
      keyword: 'type',
      params: { type: 'object' },
      message: 'must be object',
    };
    if (vErrors === null) {
      vErrors = [err15];
    } else {
      vErrors.push(err15);
    }
    errors++;
  }
  validate10.errors = vErrors;
  return errors === 0;
}
export const validateUrlParamValue = validate11;
const schema12 = { type: 'string', maxLength: 10000 };
function validate11(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data } = {}
) {
  let vErrors = null;
  let errors = 0;
  if (typeof data !== 'string') {
    let dataType0 = typeof data;
    let coerced0 = undefined;
    if (!(coerced0 !== undefined)) {
      if (dataType0 == 'number' || dataType0 == 'boolean') {
        coerced0 = '' + data;
      } else if (data === null) {
        coerced0 = '';
      } else {
        const err0 = {
          instancePath,
          schemaPath: '#/type',
          keyword: 'type',
          params: { type: 'string' },
          message: 'must be string',
        };
        if (vErrors === null) {
          vErrors = [err0];
        } else {
          vErrors.push(err0);
        }
        errors++;
      }
    }
    if (coerced0 !== undefined) {
      data = coerced0;
      if (parentData !== undefined) {
        parentData[parentDataProperty] = coerced0;
      }
    }
  }
  if (typeof data === 'string') {
    if (func2(data) > 10000) {
      const err1 = {
        instancePath,
        schemaPath: '#/maxLength',
        keyword: 'maxLength',
        params: { limit: 10000 },
        message: 'must NOT have more than 10000 characters',
      };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
  }
  validate11.errors = vErrors;
  return errors === 0;
}
export const validateDraftState = validate12;
const schema13 = {
  type: 'object',
  required: ['fileName', 'fileContent'],
  properties: {
    fileName: { type: 'string', minLength: 1, maxLength: 255 },
    fileContent: { type: 'string', maxLength: 5242880 },
    parameters: { type: 'object', default: {} },
    defaults: { type: 'object', default: {} },
    version: { type: ['number', 'string'], default: 1 },
    timestamp: { type: 'number', default: 0 },
  },
};
function validate12(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data } = {}
) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == 'object' && !Array.isArray(data)) {
    if (data.parameters === undefined) {
      data.parameters = {};
    }
    if (data.defaults === undefined) {
      data.defaults = {};
    }
    if (data.version === undefined) {
      data.version = 1;
    }
    if (data.timestamp === undefined) {
      data.timestamp = 0;
    }
    if (data.fileName === undefined) {
      const err0 = {
        instancePath,
        schemaPath: '#/required',
        keyword: 'required',
        params: { missingProperty: 'fileName' },
        message: "must have required property '" + 'fileName' + "'",
      };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.fileContent === undefined) {
      const err1 = {
        instancePath,
        schemaPath: '#/required',
        keyword: 'required',
        params: { missingProperty: 'fileContent' },
        message: "must have required property '" + 'fileContent' + "'",
      };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    if (data.fileName !== undefined) {
      let data0 = data.fileName;
      if (typeof data0 !== 'string') {
        let dataType0 = typeof data0;
        let coerced0 = undefined;
        if (!(coerced0 !== undefined)) {
          if (dataType0 == 'number' || dataType0 == 'boolean') {
            coerced0 = '' + data0;
          } else if (data0 === null) {
            coerced0 = '';
          } else {
            const err2 = {
              instancePath: instancePath + '/fileName',
              schemaPath: '#/properties/fileName/type',
              keyword: 'type',
              params: { type: 'string' },
              message: 'must be string',
            };
            if (vErrors === null) {
              vErrors = [err2];
            } else {
              vErrors.push(err2);
            }
            errors++;
          }
        }
        if (coerced0 !== undefined) {
          data0 = coerced0;
          if (data !== undefined) {
            data['fileName'] = coerced0;
          }
        }
      }
      if (typeof data0 === 'string') {
        if (func2(data0) > 255) {
          const err3 = {
            instancePath: instancePath + '/fileName',
            schemaPath: '#/properties/fileName/maxLength',
            keyword: 'maxLength',
            params: { limit: 255 },
            message: 'must NOT have more than 255 characters',
          };
          if (vErrors === null) {
            vErrors = [err3];
          } else {
            vErrors.push(err3);
          }
          errors++;
        }
        if (func2(data0) < 1) {
          const err4 = {
            instancePath: instancePath + '/fileName',
            schemaPath: '#/properties/fileName/minLength',
            keyword: 'minLength',
            params: { limit: 1 },
            message: 'must NOT have fewer than 1 characters',
          };
          if (vErrors === null) {
            vErrors = [err4];
          } else {
            vErrors.push(err4);
          }
          errors++;
        }
      }
    }
    if (data.fileContent !== undefined) {
      let data1 = data.fileContent;
      if (typeof data1 !== 'string') {
        let dataType1 = typeof data1;
        let coerced1 = undefined;
        if (!(coerced1 !== undefined)) {
          if (dataType1 == 'number' || dataType1 == 'boolean') {
            coerced1 = '' + data1;
          } else if (data1 === null) {
            coerced1 = '';
          } else {
            const err5 = {
              instancePath: instancePath + '/fileContent',
              schemaPath: '#/properties/fileContent/type',
              keyword: 'type',
              params: { type: 'string' },
              message: 'must be string',
            };
            if (vErrors === null) {
              vErrors = [err5];
            } else {
              vErrors.push(err5);
            }
            errors++;
          }
        }
        if (coerced1 !== undefined) {
          data1 = coerced1;
          if (data !== undefined) {
            data['fileContent'] = coerced1;
          }
        }
      }
      if (typeof data1 === 'string') {
        if (func2(data1) > 5242880) {
          const err6 = {
            instancePath: instancePath + '/fileContent',
            schemaPath: '#/properties/fileContent/maxLength',
            keyword: 'maxLength',
            params: { limit: 5242880 },
            message: 'must NOT have more than 5242880 characters',
          };
          if (vErrors === null) {
            vErrors = [err6];
          } else {
            vErrors.push(err6);
          }
          errors++;
        }
      }
    }
    let data2 = data.parameters;
    if (!(data2 && typeof data2 == 'object' && !Array.isArray(data2))) {
      const err7 = {
        instancePath: instancePath + '/parameters',
        schemaPath: '#/properties/parameters/type',
        keyword: 'type',
        params: { type: 'object' },
        message: 'must be object',
      };
      if (vErrors === null) {
        vErrors = [err7];
      } else {
        vErrors.push(err7);
      }
      errors++;
    }
    let data3 = data.defaults;
    if (!(data3 && typeof data3 == 'object' && !Array.isArray(data3))) {
      const err8 = {
        instancePath: instancePath + '/defaults',
        schemaPath: '#/properties/defaults/type',
        keyword: 'type',
        params: { type: 'object' },
        message: 'must be object',
      };
      if (vErrors === null) {
        vErrors = [err8];
      } else {
        vErrors.push(err8);
      }
      errors++;
    }
    let data4 = data.version;
    if (
      !(typeof data4 == 'number' && isFinite(data4)) &&
      typeof data4 !== 'string'
    ) {
      let dataType2 = typeof data4;
      let coerced2 = undefined;
      if (!(coerced2 !== undefined)) {
        if (
          dataType2 == 'boolean' ||
          data4 === null ||
          (dataType2 == 'string' && data4 && data4 == +data4)
        ) {
          coerced2 = +data4;
        } else if (dataType2 == 'number' || dataType2 == 'boolean') {
          coerced2 = '' + data4;
        } else if (data4 === null) {
          coerced2 = '';
        } else {
          const err9 = {
            instancePath: instancePath + '/version',
            schemaPath: '#/properties/version/type',
            keyword: 'type',
            params: { type: schema13.properties.version.type },
            message: 'must be number,string',
          };
          if (vErrors === null) {
            vErrors = [err9];
          } else {
            vErrors.push(err9);
          }
          errors++;
        }
      }
      if (coerced2 !== undefined) {
        data4 = coerced2;
        if (data !== undefined) {
          data['version'] = coerced2;
        }
      }
    }
    let data5 = data.timestamp;
    if (!(typeof data5 == 'number' && isFinite(data5))) {
      let dataType3 = typeof data5;
      let coerced3 = undefined;
      if (!(coerced3 !== undefined)) {
        if (
          dataType3 == 'boolean' ||
          data5 === null ||
          (dataType3 == 'string' && data5 && data5 == +data5)
        ) {
          coerced3 = +data5;
        } else {
          const err10 = {
            instancePath: instancePath + '/timestamp',
            schemaPath: '#/properties/timestamp/type',
            keyword: 'type',
            params: { type: 'number' },
            message: 'must be number',
          };
          if (vErrors === null) {
            vErrors = [err10];
          } else {
            vErrors.push(err10);
          }
          errors++;
        }
      }
      if (coerced3 !== undefined) {
        data5 = coerced3;
        if (data !== undefined) {
          data['timestamp'] = coerced3;
        }
      }
    }
  } else {
    const err11 = {
      instancePath,
      schemaPath: '#/type',
      keyword: 'type',
      params: { type: 'object' },
      message: 'must be object',
    };
    if (vErrors === null) {
      vErrors = [err11];
    } else {
      vErrors.push(err11);
    }
    errors++;
  }
  validate12.errors = vErrors;
  return errors === 0;
}
export const validatePreset = validate13;
const schema14 = {
  type: 'object',
  required: ['name', 'parameters'],
  properties: {
    name: { type: 'string', minLength: 1, maxLength: 100 },
    parameters: { type: 'object' },
    version: { type: 'number', default: 1 },
    timestamp: { type: 'number', default: 0 },
  },
};
function validate13(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data } = {}
) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == 'object' && !Array.isArray(data)) {
    if (data.version === undefined) {
      data.version = 1;
    }
    if (data.timestamp === undefined) {
      data.timestamp = 0;
    }
    if (data.name === undefined) {
      const err0 = {
        instancePath,
        schemaPath: '#/required',
        keyword: 'required',
        params: { missingProperty: 'name' },
        message: "must have required property '" + 'name' + "'",
      };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.parameters === undefined) {
      const err1 = {
        instancePath,
        schemaPath: '#/required',
        keyword: 'required',
        params: { missingProperty: 'parameters' },
        message: "must have required property '" + 'parameters' + "'",
      };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    if (data.name !== undefined) {
      let data0 = data.name;
      if (typeof data0 !== 'string') {
        let dataType0 = typeof data0;
        let coerced0 = undefined;
        if (!(coerced0 !== undefined)) {
          if (dataType0 == 'number' || dataType0 == 'boolean') {
            coerced0 = '' + data0;
          } else if (data0 === null) {
            coerced0 = '';
          } else {
            const err2 = {
              instancePath: instancePath + '/name',
              schemaPath: '#/properties/name/type',
              keyword: 'type',
              params: { type: 'string' },
              message: 'must be string',
            };
            if (vErrors === null) {
              vErrors = [err2];
            } else {
              vErrors.push(err2);
            }
            errors++;
          }
        }
        if (coerced0 !== undefined) {
          data0 = coerced0;
          if (data !== undefined) {
            data['name'] = coerced0;
          }
        }
      }
      if (typeof data0 === 'string') {
        if (func2(data0) > 100) {
          const err3 = {
            instancePath: instancePath + '/name',
            schemaPath: '#/properties/name/maxLength',
            keyword: 'maxLength',
            params: { limit: 100 },
            message: 'must NOT have more than 100 characters',
          };
          if (vErrors === null) {
            vErrors = [err3];
          } else {
            vErrors.push(err3);
          }
          errors++;
        }
        if (func2(data0) < 1) {
          const err4 = {
            instancePath: instancePath + '/name',
            schemaPath: '#/properties/name/minLength',
            keyword: 'minLength',
            params: { limit: 1 },
            message: 'must NOT have fewer than 1 characters',
          };
          if (vErrors === null) {
            vErrors = [err4];
          } else {
            vErrors.push(err4);
          }
          errors++;
        }
      }
    }
    if (data.parameters !== undefined) {
      let data1 = data.parameters;
      if (!(data1 && typeof data1 == 'object' && !Array.isArray(data1))) {
        const err5 = {
          instancePath: instancePath + '/parameters',
          schemaPath: '#/properties/parameters/type',
          keyword: 'type',
          params: { type: 'object' },
          message: 'must be object',
        };
        if (vErrors === null) {
          vErrors = [err5];
        } else {
          vErrors.push(err5);
        }
        errors++;
      }
    }
    let data2 = data.version;
    if (!(typeof data2 == 'number' && isFinite(data2))) {
      let dataType1 = typeof data2;
      let coerced1 = undefined;
      if (!(coerced1 !== undefined)) {
        if (
          dataType1 == 'boolean' ||
          data2 === null ||
          (dataType1 == 'string' && data2 && data2 == +data2)
        ) {
          coerced1 = +data2;
        } else {
          const err6 = {
            instancePath: instancePath + '/version',
            schemaPath: '#/properties/version/type',
            keyword: 'type',
            params: { type: 'number' },
            message: 'must be number',
          };
          if (vErrors === null) {
            vErrors = [err6];
          } else {
            vErrors.push(err6);
          }
          errors++;
        }
      }
      if (coerced1 !== undefined) {
        data2 = coerced1;
        if (data !== undefined) {
          data['version'] = coerced1;
        }
      }
    }
    let data3 = data.timestamp;
    if (!(typeof data3 == 'number' && isFinite(data3))) {
      let dataType2 = typeof data3;
      let coerced2 = undefined;
      if (!(coerced2 !== undefined)) {
        if (
          dataType2 == 'boolean' ||
          data3 === null ||
          (dataType2 == 'string' && data3 && data3 == +data3)
        ) {
          coerced2 = +data3;
        } else {
          const err7 = {
            instancePath: instancePath + '/timestamp',
            schemaPath: '#/properties/timestamp/type',
            keyword: 'type',
            params: { type: 'number' },
            message: 'must be number',
          };
          if (vErrors === null) {
            vErrors = [err7];
          } else {
            vErrors.push(err7);
          }
          errors++;
        }
      }
      if (coerced2 !== undefined) {
        data3 = coerced2;
        if (data !== undefined) {
          data['timestamp'] = coerced2;
        }
      }
    }
  } else {
    const err8 = {
      instancePath,
      schemaPath: '#/type',
      keyword: 'type',
      params: { type: 'object' },
      message: 'must be object',
    };
    if (vErrors === null) {
      vErrors = [err8];
    } else {
      vErrors.push(err8);
    }
    errors++;
  }
  validate13.errors = vErrors;
  return errors === 0;
}
export const validatePresetsCollection = validate14;
const schema15 = {
  type: 'array',
  items: {
    type: 'object',
    required: ['name', 'parameters'],
    properties: {
      name: { type: 'string', minLength: 1, maxLength: 100 },
      parameters: { type: 'object' },
      version: { type: 'number', default: 1 },
      timestamp: { type: 'number', default: 0 },
    },
  },
  maxItems: 50,
};
function validate14(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data } = {}
) {
  let vErrors = null;
  let errors = 0;
  if (Array.isArray(data)) {
    if (data.length > 50) {
      const err0 = {
        instancePath,
        schemaPath: '#/maxItems',
        keyword: 'maxItems',
        params: { limit: 50 },
        message: 'must NOT have more than 50 items',
      };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    const len0 = data.length;
    for (let i0 = 0; i0 < len0; i0++) {
      let data0 = data[i0];
      if (data0 && typeof data0 == 'object' && !Array.isArray(data0)) {
        if (data0.version === undefined) {
          data0.version = 1;
        }
        if (data0.timestamp === undefined) {
          data0.timestamp = 0;
        }
        if (data0.name === undefined) {
          const err1 = {
            instancePath: instancePath + '/' + i0,
            schemaPath: '#/items/required',
            keyword: 'required',
            params: { missingProperty: 'name' },
            message: "must have required property '" + 'name' + "'",
          };
          if (vErrors === null) {
            vErrors = [err1];
          } else {
            vErrors.push(err1);
          }
          errors++;
        }
        if (data0.parameters === undefined) {
          const err2 = {
            instancePath: instancePath + '/' + i0,
            schemaPath: '#/items/required',
            keyword: 'required',
            params: { missingProperty: 'parameters' },
            message: "must have required property '" + 'parameters' + "'",
          };
          if (vErrors === null) {
            vErrors = [err2];
          } else {
            vErrors.push(err2);
          }
          errors++;
        }
        if (data0.name !== undefined) {
          let data1 = data0.name;
          if (typeof data1 !== 'string') {
            let dataType0 = typeof data1;
            let coerced0 = undefined;
            if (!(coerced0 !== undefined)) {
              if (dataType0 == 'number' || dataType0 == 'boolean') {
                coerced0 = '' + data1;
              } else if (data1 === null) {
                coerced0 = '';
              } else {
                const err3 = {
                  instancePath: instancePath + '/' + i0 + '/name',
                  schemaPath: '#/items/properties/name/type',
                  keyword: 'type',
                  params: { type: 'string' },
                  message: 'must be string',
                };
                if (vErrors === null) {
                  vErrors = [err3];
                } else {
                  vErrors.push(err3);
                }
                errors++;
              }
            }
            if (coerced0 !== undefined) {
              data1 = coerced0;
              if (data0 !== undefined) {
                data0['name'] = coerced0;
              }
            }
          }
          if (typeof data1 === 'string') {
            if (func2(data1) > 100) {
              const err4 = {
                instancePath: instancePath + '/' + i0 + '/name',
                schemaPath: '#/items/properties/name/maxLength',
                keyword: 'maxLength',
                params: { limit: 100 },
                message: 'must NOT have more than 100 characters',
              };
              if (vErrors === null) {
                vErrors = [err4];
              } else {
                vErrors.push(err4);
              }
              errors++;
            }
            if (func2(data1) < 1) {
              const err5 = {
                instancePath: instancePath + '/' + i0 + '/name',
                schemaPath: '#/items/properties/name/minLength',
                keyword: 'minLength',
                params: { limit: 1 },
                message: 'must NOT have fewer than 1 characters',
              };
              if (vErrors === null) {
                vErrors = [err5];
              } else {
                vErrors.push(err5);
              }
              errors++;
            }
          }
        }
        if (data0.parameters !== undefined) {
          let data2 = data0.parameters;
          if (!(data2 && typeof data2 == 'object' && !Array.isArray(data2))) {
            const err6 = {
              instancePath: instancePath + '/' + i0 + '/parameters',
              schemaPath: '#/items/properties/parameters/type',
              keyword: 'type',
              params: { type: 'object' },
              message: 'must be object',
            };
            if (vErrors === null) {
              vErrors = [err6];
            } else {
              vErrors.push(err6);
            }
            errors++;
          }
        }
        let data3 = data0.version;
        if (!(typeof data3 == 'number' && isFinite(data3))) {
          let dataType1 = typeof data3;
          let coerced1 = undefined;
          if (!(coerced1 !== undefined)) {
            if (
              dataType1 == 'boolean' ||
              data3 === null ||
              (dataType1 == 'string' && data3 && data3 == +data3)
            ) {
              coerced1 = +data3;
            } else {
              const err7 = {
                instancePath: instancePath + '/' + i0 + '/version',
                schemaPath: '#/items/properties/version/type',
                keyword: 'type',
                params: { type: 'number' },
                message: 'must be number',
              };
              if (vErrors === null) {
                vErrors = [err7];
              } else {
                vErrors.push(err7);
              }
              errors++;
            }
          }
          if (coerced1 !== undefined) {
            data3 = coerced1;
            if (data0 !== undefined) {
              data0['version'] = coerced1;
            }
          }
        }
        let data4 = data0.timestamp;
        if (!(typeof data4 == 'number' && isFinite(data4))) {
          let dataType2 = typeof data4;
          let coerced2 = undefined;
          if (!(coerced2 !== undefined)) {
            if (
              dataType2 == 'boolean' ||
              data4 === null ||
              (dataType2 == 'string' && data4 && data4 == +data4)
            ) {
              coerced2 = +data4;
            } else {
              const err8 = {
                instancePath: instancePath + '/' + i0 + '/timestamp',
                schemaPath: '#/items/properties/timestamp/type',
                keyword: 'type',
                params: { type: 'number' },
                message: 'must be number',
              };
              if (vErrors === null) {
                vErrors = [err8];
              } else {
                vErrors.push(err8);
              }
              errors++;
            }
          }
          if (coerced2 !== undefined) {
            data4 = coerced2;
            if (data0 !== undefined) {
              data0['timestamp'] = coerced2;
            }
          }
        }
      } else {
        const err9 = {
          instancePath: instancePath + '/' + i0,
          schemaPath: '#/items/type',
          keyword: 'type',
          params: { type: 'object' },
          message: 'must be object',
        };
        if (vErrors === null) {
          vErrors = [err9];
        } else {
          vErrors.push(err9);
        }
        errors++;
      }
    }
  } else {
    const err10 = {
      instancePath,
      schemaPath: '#/type',
      keyword: 'type',
      params: { type: 'array' },
      message: 'must be array',
    };
    if (vErrors === null) {
      vErrors = [err10];
    } else {
      vErrors.push(err10);
    }
    errors++;
  }
  validate14.errors = vErrors;
  return errors === 0;
}
export const validateLibraryMap = validate15;
const schema16 = {
  type: 'object',
  patternProperties: { '^[a-zA-Z0-9_-]+$': { type: 'boolean' } },
  additionalProperties: false,
};
const pattern2 = new RegExp('^[a-zA-Z0-9_-]+$', 'u');
function validate15(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data } = {}
) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == 'object' && !Array.isArray(data)) {
    for (const key0 in data) {
      if (!pattern2.test(key0)) {
        const err0 = {
          instancePath,
          schemaPath: '#/additionalProperties',
          keyword: 'additionalProperties',
          params: { additionalProperty: key0 },
          message: 'must NOT have additional properties',
        };
        if (vErrors === null) {
          vErrors = [err0];
        } else {
          vErrors.push(err0);
        }
        errors++;
      }
    }
    for (const key1 in data) {
      if (pattern2.test(key1)) {
        let data0 = data[key1];
        if (typeof data0 !== 'boolean') {
          let coerced0 = undefined;
          if (!(coerced0 !== undefined)) {
            if (data0 === 'false' || data0 === 0 || data0 === null) {
              coerced0 = false;
            } else if (data0 === 'true' || data0 === 1) {
              coerced0 = true;
            } else {
              const err1 = {
                instancePath:
                  instancePath +
                  '/' +
                  key1.replace(/~/g, '~0').replace(/\//g, '~1'),
                schemaPath:
                  '#/patternProperties/%5E%5Ba-zA-Z0-9_-%5D%2B%24/type',
                keyword: 'type',
                params: { type: 'boolean' },
                message: 'must be boolean',
              };
              if (vErrors === null) {
                vErrors = [err1];
              } else {
                vErrors.push(err1);
              }
              errors++;
            }
          }
          if (coerced0 !== undefined) {
            data0 = coerced0;
            if (data !== undefined) {
              data[key1] = coerced0;
            }
          }
        }
      }
    }
  } else {
    const err2 = {
      instancePath,
      schemaPath: '#/type',
      keyword: 'type',
      params: { type: 'object' },
      message: 'must be object',
    };
    if (vErrors === null) {
      vErrors = [err2];
    } else {
      vErrors.push(err2);
    }
    errors++;
  }
  validate15.errors = vErrors;
  return errors === 0;
}
export const validateSavedProject = validate16;
const schema17 = {
  type: 'object',
  required: [
    'id',
    'schemaVersion',
    'name',
    'originalName',
    'kind',
    'mainFilePath',
    'content',
    'notes',
    'savedAt',
    'lastLoadedAt',
  ],
  properties: {
    id: { type: 'string', minLength: 1 },
    schemaVersion: { type: 'number', minimum: 1, maximum: 100 },
    name: { type: 'string', minLength: 1, maxLength: 255 },
    originalName: { type: 'string', minLength: 1, maxLength: 255 },
    kind: { type: 'string', enum: ['scad', 'zip', 'folder-link'] },
    mainFilePath: { type: 'string', minLength: 1, maxLength: 500 },
    content: { type: 'string', maxLength: 5242880 },
    projectFiles: { type: ['string', 'null'], default: null },
    folderRef: { type: ['string', 'null'], default: null },
    fileSummary: {
      type: ['object', 'null'],
      default: null,
      properties: {
        fileCount: { type: 'number', minimum: 0 },
        totalBytes: { type: 'number', minimum: 0 },
      },
    },
    folderId: { type: ['string', 'null'], default: null },
    overlayFiles: { type: 'object', default: {} },
    presets: { type: 'array', default: [] },
    notes: { type: 'string', maxLength: 5000, default: '' },
    forkedFrom: { type: ['object', 'null'], default: null },
    uiPreferences: { type: ['object', 'null'], default: null },
    sourceExampleKey: { type: ['string', 'null'], default: null },
    savedAt: { type: 'number', minimum: 0 },
    lastLoadedAt: { type: 'number', minimum: 0 },
  },
};
function validate16(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data } = {}
) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == 'object' && !Array.isArray(data)) {
    if (data.projectFiles === undefined) {
      data.projectFiles = null;
    }
    if (data.folderRef === undefined) {
      data.folderRef = null;
    }
    if (data.fileSummary === undefined) {
      data.fileSummary = null;
    }
    if (data.folderId === undefined) {
      data.folderId = null;
    }
    if (data.overlayFiles === undefined) {
      data.overlayFiles = {};
    }
    if (data.presets === undefined) {
      data.presets = [];
    }
    if (data.notes === undefined) {
      data.notes = '';
    }
    if (data.forkedFrom === undefined) {
      data.forkedFrom = null;
    }
    if (data.uiPreferences === undefined) {
      data.uiPreferences = null;
    }
    if (data.sourceExampleKey === undefined) {
      data.sourceExampleKey = null;
    }
    if (data.id === undefined) {
      const err0 = {
        instancePath,
        schemaPath: '#/required',
        keyword: 'required',
        params: { missingProperty: 'id' },
        message: "must have required property '" + 'id' + "'",
      };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.schemaVersion === undefined) {
      const err1 = {
        instancePath,
        schemaPath: '#/required',
        keyword: 'required',
        params: { missingProperty: 'schemaVersion' },
        message: "must have required property '" + 'schemaVersion' + "'",
      };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    if (data.name === undefined) {
      const err2 = {
        instancePath,
        schemaPath: '#/required',
        keyword: 'required',
        params: { missingProperty: 'name' },
        message: "must have required property '" + 'name' + "'",
      };
      if (vErrors === null) {
        vErrors = [err2];
      } else {
        vErrors.push(err2);
      }
      errors++;
    }
    if (data.originalName === undefined) {
      const err3 = {
        instancePath,
        schemaPath: '#/required',
        keyword: 'required',
        params: { missingProperty: 'originalName' },
        message: "must have required property '" + 'originalName' + "'",
      };
      if (vErrors === null) {
        vErrors = [err3];
      } else {
        vErrors.push(err3);
      }
      errors++;
    }
    if (data.kind === undefined) {
      const err4 = {
        instancePath,
        schemaPath: '#/required',
        keyword: 'required',
        params: { missingProperty: 'kind' },
        message: "must have required property '" + 'kind' + "'",
      };
      if (vErrors === null) {
        vErrors = [err4];
      } else {
        vErrors.push(err4);
      }
      errors++;
    }
    if (data.mainFilePath === undefined) {
      const err5 = {
        instancePath,
        schemaPath: '#/required',
        keyword: 'required',
        params: { missingProperty: 'mainFilePath' },
        message: "must have required property '" + 'mainFilePath' + "'",
      };
      if (vErrors === null) {
        vErrors = [err5];
      } else {
        vErrors.push(err5);
      }
      errors++;
    }
    if (data.content === undefined) {
      const err6 = {
        instancePath,
        schemaPath: '#/required',
        keyword: 'required',
        params: { missingProperty: 'content' },
        message: "must have required property '" + 'content' + "'",
      };
      if (vErrors === null) {
        vErrors = [err6];
      } else {
        vErrors.push(err6);
      }
      errors++;
    }
    if (data.notes === undefined) {
      const err7 = {
        instancePath,
        schemaPath: '#/required',
        keyword: 'required',
        params: { missingProperty: 'notes' },
        message: "must have required property '" + 'notes' + "'",
      };
      if (vErrors === null) {
        vErrors = [err7];
      } else {
        vErrors.push(err7);
      }
      errors++;
    }
    if (data.savedAt === undefined) {
      const err8 = {
        instancePath,
        schemaPath: '#/required',
        keyword: 'required',
        params: { missingProperty: 'savedAt' },
        message: "must have required property '" + 'savedAt' + "'",
      };
      if (vErrors === null) {
        vErrors = [err8];
      } else {
        vErrors.push(err8);
      }
      errors++;
    }
    if (data.lastLoadedAt === undefined) {
      const err9 = {
        instancePath,
        schemaPath: '#/required',
        keyword: 'required',
        params: { missingProperty: 'lastLoadedAt' },
        message: "must have required property '" + 'lastLoadedAt' + "'",
      };
      if (vErrors === null) {
        vErrors = [err9];
      } else {
        vErrors.push(err9);
      }
      errors++;
    }
    if (data.id !== undefined) {
      let data0 = data.id;
      if (typeof data0 !== 'string') {
        let dataType0 = typeof data0;
        let coerced0 = undefined;
        if (!(coerced0 !== undefined)) {
          if (dataType0 == 'number' || dataType0 == 'boolean') {
            coerced0 = '' + data0;
          } else if (data0 === null) {
            coerced0 = '';
          } else {
            const err10 = {
              instancePath: instancePath + '/id',
              schemaPath: '#/properties/id/type',
              keyword: 'type',
              params: { type: 'string' },
              message: 'must be string',
            };
            if (vErrors === null) {
              vErrors = [err10];
            } else {
              vErrors.push(err10);
            }
            errors++;
          }
        }
        if (coerced0 !== undefined) {
          data0 = coerced0;
          if (data !== undefined) {
            data['id'] = coerced0;
          }
        }
      }
      if (typeof data0 === 'string') {
        if (func2(data0) < 1) {
          const err11 = {
            instancePath: instancePath + '/id',
            schemaPath: '#/properties/id/minLength',
            keyword: 'minLength',
            params: { limit: 1 },
            message: 'must NOT have fewer than 1 characters',
          };
          if (vErrors === null) {
            vErrors = [err11];
          } else {
            vErrors.push(err11);
          }
          errors++;
        }
      }
    }
    if (data.schemaVersion !== undefined) {
      let data1 = data.schemaVersion;
      if (!(typeof data1 == 'number' && isFinite(data1))) {
        let dataType1 = typeof data1;
        let coerced1 = undefined;
        if (!(coerced1 !== undefined)) {
          if (
            dataType1 == 'boolean' ||
            data1 === null ||
            (dataType1 == 'string' && data1 && data1 == +data1)
          ) {
            coerced1 = +data1;
          } else {
            const err12 = {
              instancePath: instancePath + '/schemaVersion',
              schemaPath: '#/properties/schemaVersion/type',
              keyword: 'type',
              params: { type: 'number' },
              message: 'must be number',
            };
            if (vErrors === null) {
              vErrors = [err12];
            } else {
              vErrors.push(err12);
            }
            errors++;
          }
        }
        if (coerced1 !== undefined) {
          data1 = coerced1;
          if (data !== undefined) {
            data['schemaVersion'] = coerced1;
          }
        }
      }
      if (typeof data1 == 'number' && isFinite(data1)) {
        if (data1 > 100 || isNaN(data1)) {
          const err13 = {
            instancePath: instancePath + '/schemaVersion',
            schemaPath: '#/properties/schemaVersion/maximum',
            keyword: 'maximum',
            params: { comparison: '<=', limit: 100 },
            message: 'must be <= 100',
          };
          if (vErrors === null) {
            vErrors = [err13];
          } else {
            vErrors.push(err13);
          }
          errors++;
        }
        if (data1 < 1 || isNaN(data1)) {
          const err14 = {
            instancePath: instancePath + '/schemaVersion',
            schemaPath: '#/properties/schemaVersion/minimum',
            keyword: 'minimum',
            params: { comparison: '>=', limit: 1 },
            message: 'must be >= 1',
          };
          if (vErrors === null) {
            vErrors = [err14];
          } else {
            vErrors.push(err14);
          }
          errors++;
        }
      }
    }
    if (data.name !== undefined) {
      let data2 = data.name;
      if (typeof data2 !== 'string') {
        let dataType2 = typeof data2;
        let coerced2 = undefined;
        if (!(coerced2 !== undefined)) {
          if (dataType2 == 'number' || dataType2 == 'boolean') {
            coerced2 = '' + data2;
          } else if (data2 === null) {
            coerced2 = '';
          } else {
            const err15 = {
              instancePath: instancePath + '/name',
              schemaPath: '#/properties/name/type',
              keyword: 'type',
              params: { type: 'string' },
              message: 'must be string',
            };
            if (vErrors === null) {
              vErrors = [err15];
            } else {
              vErrors.push(err15);
            }
            errors++;
          }
        }
        if (coerced2 !== undefined) {
          data2 = coerced2;
          if (data !== undefined) {
            data['name'] = coerced2;
          }
        }
      }
      if (typeof data2 === 'string') {
        if (func2(data2) > 255) {
          const err16 = {
            instancePath: instancePath + '/name',
            schemaPath: '#/properties/name/maxLength',
            keyword: 'maxLength',
            params: { limit: 255 },
            message: 'must NOT have more than 255 characters',
          };
          if (vErrors === null) {
            vErrors = [err16];
          } else {
            vErrors.push(err16);
          }
          errors++;
        }
        if (func2(data2) < 1) {
          const err17 = {
            instancePath: instancePath + '/name',
            schemaPath: '#/properties/name/minLength',
            keyword: 'minLength',
            params: { limit: 1 },
            message: 'must NOT have fewer than 1 characters',
          };
          if (vErrors === null) {
            vErrors = [err17];
          } else {
            vErrors.push(err17);
          }
          errors++;
        }
      }
    }
    if (data.originalName !== undefined) {
      let data3 = data.originalName;
      if (typeof data3 !== 'string') {
        let dataType3 = typeof data3;
        let coerced3 = undefined;
        if (!(coerced3 !== undefined)) {
          if (dataType3 == 'number' || dataType3 == 'boolean') {
            coerced3 = '' + data3;
          } else if (data3 === null) {
            coerced3 = '';
          } else {
            const err18 = {
              instancePath: instancePath + '/originalName',
              schemaPath: '#/properties/originalName/type',
              keyword: 'type',
              params: { type: 'string' },
              message: 'must be string',
            };
            if (vErrors === null) {
              vErrors = [err18];
            } else {
              vErrors.push(err18);
            }
            errors++;
          }
        }
        if (coerced3 !== undefined) {
          data3 = coerced3;
          if (data !== undefined) {
            data['originalName'] = coerced3;
          }
        }
      }
      if (typeof data3 === 'string') {
        if (func2(data3) > 255) {
          const err19 = {
            instancePath: instancePath + '/originalName',
            schemaPath: '#/properties/originalName/maxLength',
            keyword: 'maxLength',
            params: { limit: 255 },
            message: 'must NOT have more than 255 characters',
          };
          if (vErrors === null) {
            vErrors = [err19];
          } else {
            vErrors.push(err19);
          }
          errors++;
        }
        if (func2(data3) < 1) {
          const err20 = {
            instancePath: instancePath + '/originalName',
            schemaPath: '#/properties/originalName/minLength',
            keyword: 'minLength',
            params: { limit: 1 },
            message: 'must NOT have fewer than 1 characters',
          };
          if (vErrors === null) {
            vErrors = [err20];
          } else {
            vErrors.push(err20);
          }
          errors++;
        }
      }
    }
    if (data.kind !== undefined) {
      let data4 = data.kind;
      if (typeof data4 !== 'string') {
        let dataType4 = typeof data4;
        let coerced4 = undefined;
        if (!(coerced4 !== undefined)) {
          if (dataType4 == 'number' || dataType4 == 'boolean') {
            coerced4 = '' + data4;
          } else if (data4 === null) {
            coerced4 = '';
          } else {
            const err21 = {
              instancePath: instancePath + '/kind',
              schemaPath: '#/properties/kind/type',
              keyword: 'type',
              params: { type: 'string' },
              message: 'must be string',
            };
            if (vErrors === null) {
              vErrors = [err21];
            } else {
              vErrors.push(err21);
            }
            errors++;
          }
        }
        if (coerced4 !== undefined) {
          data4 = coerced4;
          if (data !== undefined) {
            data['kind'] = coerced4;
          }
        }
      }
      if (!(data4 === 'scad' || data4 === 'zip' || data4 === 'folder-link')) {
        const err22 = {
          instancePath: instancePath + '/kind',
          schemaPath: '#/properties/kind/enum',
          keyword: 'enum',
          params: { allowedValues: schema17.properties.kind.enum },
          message: 'must be equal to one of the allowed values',
        };
        if (vErrors === null) {
          vErrors = [err22];
        } else {
          vErrors.push(err22);
        }
        errors++;
      }
    }
    if (data.mainFilePath !== undefined) {
      let data5 = data.mainFilePath;
      if (typeof data5 !== 'string') {
        let dataType5 = typeof data5;
        let coerced5 = undefined;
        if (!(coerced5 !== undefined)) {
          if (dataType5 == 'number' || dataType5 == 'boolean') {
            coerced5 = '' + data5;
          } else if (data5 === null) {
            coerced5 = '';
          } else {
            const err23 = {
              instancePath: instancePath + '/mainFilePath',
              schemaPath: '#/properties/mainFilePath/type',
              keyword: 'type',
              params: { type: 'string' },
              message: 'must be string',
            };
            if (vErrors === null) {
              vErrors = [err23];
            } else {
              vErrors.push(err23);
            }
            errors++;
          }
        }
        if (coerced5 !== undefined) {
          data5 = coerced5;
          if (data !== undefined) {
            data['mainFilePath'] = coerced5;
          }
        }
      }
      if (typeof data5 === 'string') {
        if (func2(data5) > 500) {
          const err24 = {
            instancePath: instancePath + '/mainFilePath',
            schemaPath: '#/properties/mainFilePath/maxLength',
            keyword: 'maxLength',
            params: { limit: 500 },
            message: 'must NOT have more than 500 characters',
          };
          if (vErrors === null) {
            vErrors = [err24];
          } else {
            vErrors.push(err24);
          }
          errors++;
        }
        if (func2(data5) < 1) {
          const err25 = {
            instancePath: instancePath + '/mainFilePath',
            schemaPath: '#/properties/mainFilePath/minLength',
            keyword: 'minLength',
            params: { limit: 1 },
            message: 'must NOT have fewer than 1 characters',
          };
          if (vErrors === null) {
            vErrors = [err25];
          } else {
            vErrors.push(err25);
          }
          errors++;
        }
      }
    }
    if (data.content !== undefined) {
      let data6 = data.content;
      if (typeof data6 !== 'string') {
        let dataType6 = typeof data6;
        let coerced6 = undefined;
        if (!(coerced6 !== undefined)) {
          if (dataType6 == 'number' || dataType6 == 'boolean') {
            coerced6 = '' + data6;
          } else if (data6 === null) {
            coerced6 = '';
          } else {
            const err26 = {
              instancePath: instancePath + '/content',
              schemaPath: '#/properties/content/type',
              keyword: 'type',
              params: { type: 'string' },
              message: 'must be string',
            };
            if (vErrors === null) {
              vErrors = [err26];
            } else {
              vErrors.push(err26);
            }
            errors++;
          }
        }
        if (coerced6 !== undefined) {
          data6 = coerced6;
          if (data !== undefined) {
            data['content'] = coerced6;
          }
        }
      }
      if (typeof data6 === 'string') {
        if (func2(data6) > 5242880) {
          const err27 = {
            instancePath: instancePath + '/content',
            schemaPath: '#/properties/content/maxLength',
            keyword: 'maxLength',
            params: { limit: 5242880 },
            message: 'must NOT have more than 5242880 characters',
          };
          if (vErrors === null) {
            vErrors = [err27];
          } else {
            vErrors.push(err27);
          }
          errors++;
        }
      }
    }
    let data7 = data.projectFiles;
    if (typeof data7 !== 'string' && data7 !== null) {
      let dataType7 = typeof data7;
      let coerced7 = undefined;
      if (!(coerced7 !== undefined)) {
        if (dataType7 == 'number' || dataType7 == 'boolean') {
          coerced7 = '' + data7;
        } else if (data7 === null) {
          coerced7 = '';
        } else if (data7 === '' || data7 === 0 || data7 === false) {
          coerced7 = null;
        } else {
          const err28 = {
            instancePath: instancePath + '/projectFiles',
            schemaPath: '#/properties/projectFiles/type',
            keyword: 'type',
            params: { type: schema17.properties.projectFiles.type },
            message: 'must be string,null',
          };
          if (vErrors === null) {
            vErrors = [err28];
          } else {
            vErrors.push(err28);
          }
          errors++;
        }
      }
      if (coerced7 !== undefined) {
        data7 = coerced7;
        if (data !== undefined) {
          data['projectFiles'] = coerced7;
        }
      }
    }
    let data8 = data.folderRef;
    if (typeof data8 !== 'string' && data8 !== null) {
      let dataType8 = typeof data8;
      let coerced8 = undefined;
      if (!(coerced8 !== undefined)) {
        if (dataType8 == 'number' || dataType8 == 'boolean') {
          coerced8 = '' + data8;
        } else if (data8 === null) {
          coerced8 = '';
        } else if (data8 === '' || data8 === 0 || data8 === false) {
          coerced8 = null;
        } else {
          const err29 = {
            instancePath: instancePath + '/folderRef',
            schemaPath: '#/properties/folderRef/type',
            keyword: 'type',
            params: { type: schema17.properties.folderRef.type },
            message: 'must be string,null',
          };
          if (vErrors === null) {
            vErrors = [err29];
          } else {
            vErrors.push(err29);
          }
          errors++;
        }
      }
      if (coerced8 !== undefined) {
        data8 = coerced8;
        if (data !== undefined) {
          data['folderRef'] = coerced8;
        }
      }
    }
    let data9 = data.fileSummary;
    if (
      !(data9 && typeof data9 == 'object' && !Array.isArray(data9)) &&
      data9 !== null
    ) {
      let coerced9 = undefined;
      if (!(coerced9 !== undefined)) {
        if (data9 === '' || data9 === 0 || data9 === false) {
          coerced9 = null;
        } else {
          const err30 = {
            instancePath: instancePath + '/fileSummary',
            schemaPath: '#/properties/fileSummary/type',
            keyword: 'type',
            params: { type: schema17.properties.fileSummary.type },
            message: 'must be object,null',
          };
          if (vErrors === null) {
            vErrors = [err30];
          } else {
            vErrors.push(err30);
          }
          errors++;
        }
      }
      if (coerced9 !== undefined) {
        data9 = coerced9;
        if (data !== undefined) {
          data['fileSummary'] = coerced9;
        }
      }
    }
    if (data9 && typeof data9 == 'object' && !Array.isArray(data9)) {
      if (data9.fileCount !== undefined) {
        let data10 = data9.fileCount;
        if (!(typeof data10 == 'number' && isFinite(data10))) {
          let dataType10 = typeof data10;
          let coerced10 = undefined;
          if (!(coerced10 !== undefined)) {
            if (
              dataType10 == 'boolean' ||
              data10 === null ||
              (dataType10 == 'string' && data10 && data10 == +data10)
            ) {
              coerced10 = +data10;
            } else {
              const err31 = {
                instancePath: instancePath + '/fileSummary/fileCount',
                schemaPath:
                  '#/properties/fileSummary/properties/fileCount/type',
                keyword: 'type',
                params: { type: 'number' },
                message: 'must be number',
              };
              if (vErrors === null) {
                vErrors = [err31];
              } else {
                vErrors.push(err31);
              }
              errors++;
            }
          }
          if (coerced10 !== undefined) {
            data10 = coerced10;
            if (data9 !== undefined) {
              data9['fileCount'] = coerced10;
            }
          }
        }
        if (typeof data10 == 'number' && isFinite(data10)) {
          if (data10 < 0 || isNaN(data10)) {
            const err32 = {
              instancePath: instancePath + '/fileSummary/fileCount',
              schemaPath:
                '#/properties/fileSummary/properties/fileCount/minimum',
              keyword: 'minimum',
              params: { comparison: '>=', limit: 0 },
              message: 'must be >= 0',
            };
            if (vErrors === null) {
              vErrors = [err32];
            } else {
              vErrors.push(err32);
            }
            errors++;
          }
        }
      }
      if (data9.totalBytes !== undefined) {
        let data11 = data9.totalBytes;
        if (!(typeof data11 == 'number' && isFinite(data11))) {
          let dataType11 = typeof data11;
          let coerced11 = undefined;
          if (!(coerced11 !== undefined)) {
            if (
              dataType11 == 'boolean' ||
              data11 === null ||
              (dataType11 == 'string' && data11 && data11 == +data11)
            ) {
              coerced11 = +data11;
            } else {
              const err33 = {
                instancePath: instancePath + '/fileSummary/totalBytes',
                schemaPath:
                  '#/properties/fileSummary/properties/totalBytes/type',
                keyword: 'type',
                params: { type: 'number' },
                message: 'must be number',
              };
              if (vErrors === null) {
                vErrors = [err33];
              } else {
                vErrors.push(err33);
              }
              errors++;
            }
          }
          if (coerced11 !== undefined) {
            data11 = coerced11;
            if (data9 !== undefined) {
              data9['totalBytes'] = coerced11;
            }
          }
        }
        if (typeof data11 == 'number' && isFinite(data11)) {
          if (data11 < 0 || isNaN(data11)) {
            const err34 = {
              instancePath: instancePath + '/fileSummary/totalBytes',
              schemaPath:
                '#/properties/fileSummary/properties/totalBytes/minimum',
              keyword: 'minimum',
              params: { comparison: '>=', limit: 0 },
              message: 'must be >= 0',
            };
            if (vErrors === null) {
              vErrors = [err34];
            } else {
              vErrors.push(err34);
            }
            errors++;
          }
        }
      }
    }
    let data12 = data.folderId;
    if (typeof data12 !== 'string' && data12 !== null) {
      let dataType12 = typeof data12;
      let coerced12 = undefined;
      if (!(coerced12 !== undefined)) {
        if (dataType12 == 'number' || dataType12 == 'boolean') {
          coerced12 = '' + data12;
        } else if (data12 === null) {
          coerced12 = '';
        } else if (data12 === '' || data12 === 0 || data12 === false) {
          coerced12 = null;
        } else {
          const err35 = {
            instancePath: instancePath + '/folderId',
            schemaPath: '#/properties/folderId/type',
            keyword: 'type',
            params: { type: schema17.properties.folderId.type },
            message: 'must be string,null',
          };
          if (vErrors === null) {
            vErrors = [err35];
          } else {
            vErrors.push(err35);
          }
          errors++;
        }
      }
      if (coerced12 !== undefined) {
        data12 = coerced12;
        if (data !== undefined) {
          data['folderId'] = coerced12;
        }
      }
    }
    let data13 = data.overlayFiles;
    if (!(data13 && typeof data13 == 'object' && !Array.isArray(data13))) {
      const err36 = {
        instancePath: instancePath + '/overlayFiles',
        schemaPath: '#/properties/overlayFiles/type',
        keyword: 'type',
        params: { type: 'object' },
        message: 'must be object',
      };
      if (vErrors === null) {
        vErrors = [err36];
      } else {
        vErrors.push(err36);
      }
      errors++;
    }
    if (!Array.isArray(data.presets)) {
      const err37 = {
        instancePath: instancePath + '/presets',
        schemaPath: '#/properties/presets/type',
        keyword: 'type',
        params: { type: 'array' },
        message: 'must be array',
      };
      if (vErrors === null) {
        vErrors = [err37];
      } else {
        vErrors.push(err37);
      }
      errors++;
    }
    let data15 = data.notes;
    if (typeof data15 !== 'string') {
      let dataType13 = typeof data15;
      let coerced13 = undefined;
      if (!(coerced13 !== undefined)) {
        if (dataType13 == 'number' || dataType13 == 'boolean') {
          coerced13 = '' + data15;
        } else if (data15 === null) {
          coerced13 = '';
        } else {
          const err38 = {
            instancePath: instancePath + '/notes',
            schemaPath: '#/properties/notes/type',
            keyword: 'type',
            params: { type: 'string' },
            message: 'must be string',
          };
          if (vErrors === null) {
            vErrors = [err38];
          } else {
            vErrors.push(err38);
          }
          errors++;
        }
      }
      if (coerced13 !== undefined) {
        data15 = coerced13;
        if (data !== undefined) {
          data['notes'] = coerced13;
        }
      }
    }
    if (typeof data15 === 'string') {
      if (func2(data15) > 5000) {
        const err39 = {
          instancePath: instancePath + '/notes',
          schemaPath: '#/properties/notes/maxLength',
          keyword: 'maxLength',
          params: { limit: 5000 },
          message: 'must NOT have more than 5000 characters',
        };
        if (vErrors === null) {
          vErrors = [err39];
        } else {
          vErrors.push(err39);
        }
        errors++;
      }
    }
    let data16 = data.forkedFrom;
    if (
      !(data16 && typeof data16 == 'object' && !Array.isArray(data16)) &&
      data16 !== null
    ) {
      let coerced14 = undefined;
      if (!(coerced14 !== undefined)) {
        if (data16 === '' || data16 === 0 || data16 === false) {
          coerced14 = null;
        } else {
          const err40 = {
            instancePath: instancePath + '/forkedFrom',
            schemaPath: '#/properties/forkedFrom/type',
            keyword: 'type',
            params: { type: schema17.properties.forkedFrom.type },
            message: 'must be object,null',
          };
          if (vErrors === null) {
            vErrors = [err40];
          } else {
            vErrors.push(err40);
          }
          errors++;
        }
      }
      if (coerced14 !== undefined) {
        data16 = coerced14;
        if (data !== undefined) {
          data['forkedFrom'] = coerced14;
        }
      }
    }
    let data17 = data.uiPreferences;
    if (
      !(data17 && typeof data17 == 'object' && !Array.isArray(data17)) &&
      data17 !== null
    ) {
      let coerced15 = undefined;
      if (!(coerced15 !== undefined)) {
        if (data17 === '' || data17 === 0 || data17 === false) {
          coerced15 = null;
        } else {
          const err41 = {
            instancePath: instancePath + '/uiPreferences',
            schemaPath: '#/properties/uiPreferences/type',
            keyword: 'type',
            params: { type: schema17.properties.uiPreferences.type },
            message: 'must be object,null',
          };
          if (vErrors === null) {
            vErrors = [err41];
          } else {
            vErrors.push(err41);
          }
          errors++;
        }
      }
      if (coerced15 !== undefined) {
        data17 = coerced15;
        if (data !== undefined) {
          data['uiPreferences'] = coerced15;
        }
      }
    }
    let data18 = data.sourceExampleKey;
    if (typeof data18 !== 'string' && data18 !== null) {
      let dataType16 = typeof data18;
      let coerced16 = undefined;
      if (!(coerced16 !== undefined)) {
        if (dataType16 == 'number' || dataType16 == 'boolean') {
          coerced16 = '' + data18;
        } else if (data18 === null) {
          coerced16 = '';
        } else if (data18 === '' || data18 === 0 || data18 === false) {
          coerced16 = null;
        } else {
          const err42 = {
            instancePath: instancePath + '/sourceExampleKey',
            schemaPath: '#/properties/sourceExampleKey/type',
            keyword: 'type',
            params: { type: schema17.properties.sourceExampleKey.type },
            message: 'must be string,null',
          };
          if (vErrors === null) {
            vErrors = [err42];
          } else {
            vErrors.push(err42);
          }
          errors++;
        }
      }
      if (coerced16 !== undefined) {
        data18 = coerced16;
        if (data !== undefined) {
          data['sourceExampleKey'] = coerced16;
        }
      }
    }
    if (data.savedAt !== undefined) {
      let data19 = data.savedAt;
      if (!(typeof data19 == 'number' && isFinite(data19))) {
        let dataType17 = typeof data19;
        let coerced17 = undefined;
        if (!(coerced17 !== undefined)) {
          if (
            dataType17 == 'boolean' ||
            data19 === null ||
            (dataType17 == 'string' && data19 && data19 == +data19)
          ) {
            coerced17 = +data19;
          } else {
            const err43 = {
              instancePath: instancePath + '/savedAt',
              schemaPath: '#/properties/savedAt/type',
              keyword: 'type',
              params: { type: 'number' },
              message: 'must be number',
            };
            if (vErrors === null) {
              vErrors = [err43];
            } else {
              vErrors.push(err43);
            }
            errors++;
          }
        }
        if (coerced17 !== undefined) {
          data19 = coerced17;
          if (data !== undefined) {
            data['savedAt'] = coerced17;
          }
        }
      }
      if (typeof data19 == 'number' && isFinite(data19)) {
        if (data19 < 0 || isNaN(data19)) {
          const err44 = {
            instancePath: instancePath + '/savedAt',
            schemaPath: '#/properties/savedAt/minimum',
            keyword: 'minimum',
            params: { comparison: '>=', limit: 0 },
            message: 'must be >= 0',
          };
          if (vErrors === null) {
            vErrors = [err44];
          } else {
            vErrors.push(err44);
          }
          errors++;
        }
      }
    }
    if (data.lastLoadedAt !== undefined) {
      let data20 = data.lastLoadedAt;
      if (!(typeof data20 == 'number' && isFinite(data20))) {
        let dataType18 = typeof data20;
        let coerced18 = undefined;
        if (!(coerced18 !== undefined)) {
          if (
            dataType18 == 'boolean' ||
            data20 === null ||
            (dataType18 == 'string' && data20 && data20 == +data20)
          ) {
            coerced18 = +data20;
          } else {
            const err45 = {
              instancePath: instancePath + '/lastLoadedAt',
              schemaPath: '#/properties/lastLoadedAt/type',
              keyword: 'type',
              params: { type: 'number' },
              message: 'must be number',
            };
            if (vErrors === null) {
              vErrors = [err45];
            } else {
              vErrors.push(err45);
            }
            errors++;
          }
        }
        if (coerced18 !== undefined) {
          data20 = coerced18;
          if (data !== undefined) {
            data['lastLoadedAt'] = coerced18;
          }
        }
      }
      if (typeof data20 == 'number' && isFinite(data20)) {
        if (data20 < 0 || isNaN(data20)) {
          const err46 = {
            instancePath: instancePath + '/lastLoadedAt',
            schemaPath: '#/properties/lastLoadedAt/minimum',
            keyword: 'minimum',
            params: { comparison: '>=', limit: 0 },
            message: 'must be >= 0',
          };
          if (vErrors === null) {
            vErrors = [err46];
          } else {
            vErrors.push(err46);
          }
          errors++;
        }
      }
    }
  } else {
    const err47 = {
      instancePath,
      schemaPath: '#/type',
      keyword: 'type',
      params: { type: 'object' },
      message: 'must be object',
    };
    if (vErrors === null) {
      vErrors = [err47];
    } else {
      vErrors.push(err47);
    }
    errors++;
  }
  validate16.errors = vErrors;
  return errors === 0;
}
export const validateSavedProjectsCollection = validate17;
const schema18 = {
  type: 'array',
  items: {
    type: 'object',
    required: [
      'id',
      'schemaVersion',
      'name',
      'originalName',
      'kind',
      'mainFilePath',
      'content',
      'notes',
      'savedAt',
      'lastLoadedAt',
    ],
    properties: {
      id: { type: 'string', minLength: 1 },
      schemaVersion: { type: 'number', minimum: 1, maximum: 100 },
      name: { type: 'string', minLength: 1, maxLength: 255 },
      originalName: { type: 'string', minLength: 1, maxLength: 255 },
      kind: { type: 'string', enum: ['scad', 'zip', 'folder-link'] },
      mainFilePath: { type: 'string', minLength: 1, maxLength: 500 },
      content: { type: 'string', maxLength: 5242880 },
      projectFiles: { type: ['string', 'null'], default: null },
      folderRef: { type: ['string', 'null'], default: null },
      fileSummary: {
        type: ['object', 'null'],
        default: null,
        properties: {
          fileCount: { type: 'number', minimum: 0 },
          totalBytes: { type: 'number', minimum: 0 },
        },
      },
      folderId: { type: ['string', 'null'], default: null },
      overlayFiles: { type: 'object', default: {} },
      presets: { type: 'array', default: [] },
      notes: { type: 'string', maxLength: 5000, default: '' },
      forkedFrom: { type: ['object', 'null'], default: null },
      uiPreferences: { type: ['object', 'null'], default: null },
      sourceExampleKey: { type: ['string', 'null'], default: null },
      savedAt: { type: 'number', minimum: 0 },
      lastLoadedAt: { type: 'number', minimum: 0 },
    },
  },
  maxItems: 25,
};
function validate17(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data } = {}
) {
  let vErrors = null;
  let errors = 0;
  if (Array.isArray(data)) {
    if (data.length > 25) {
      const err0 = {
        instancePath,
        schemaPath: '#/maxItems',
        keyword: 'maxItems',
        params: { limit: 25 },
        message: 'must NOT have more than 25 items',
      };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    const len0 = data.length;
    for (let i0 = 0; i0 < len0; i0++) {
      let data0 = data[i0];
      if (data0 && typeof data0 == 'object' && !Array.isArray(data0)) {
        if (data0.projectFiles === undefined) {
          data0.projectFiles = null;
        }
        if (data0.folderRef === undefined) {
          data0.folderRef = null;
        }
        if (data0.fileSummary === undefined) {
          data0.fileSummary = null;
        }
        if (data0.folderId === undefined) {
          data0.folderId = null;
        }
        if (data0.overlayFiles === undefined) {
          data0.overlayFiles = {};
        }
        if (data0.presets === undefined) {
          data0.presets = [];
        }
        if (data0.notes === undefined) {
          data0.notes = '';
        }
        if (data0.forkedFrom === undefined) {
          data0.forkedFrom = null;
        }
        if (data0.uiPreferences === undefined) {
          data0.uiPreferences = null;
        }
        if (data0.sourceExampleKey === undefined) {
          data0.sourceExampleKey = null;
        }
        if (data0.id === undefined) {
          const err1 = {
            instancePath: instancePath + '/' + i0,
            schemaPath: '#/items/required',
            keyword: 'required',
            params: { missingProperty: 'id' },
            message: "must have required property '" + 'id' + "'",
          };
          if (vErrors === null) {
            vErrors = [err1];
          } else {
            vErrors.push(err1);
          }
          errors++;
        }
        if (data0.schemaVersion === undefined) {
          const err2 = {
            instancePath: instancePath + '/' + i0,
            schemaPath: '#/items/required',
            keyword: 'required',
            params: { missingProperty: 'schemaVersion' },
            message: "must have required property '" + 'schemaVersion' + "'",
          };
          if (vErrors === null) {
            vErrors = [err2];
          } else {
            vErrors.push(err2);
          }
          errors++;
        }
        if (data0.name === undefined) {
          const err3 = {
            instancePath: instancePath + '/' + i0,
            schemaPath: '#/items/required',
            keyword: 'required',
            params: { missingProperty: 'name' },
            message: "must have required property '" + 'name' + "'",
          };
          if (vErrors === null) {
            vErrors = [err3];
          } else {
            vErrors.push(err3);
          }
          errors++;
        }
        if (data0.originalName === undefined) {
          const err4 = {
            instancePath: instancePath + '/' + i0,
            schemaPath: '#/items/required',
            keyword: 'required',
            params: { missingProperty: 'originalName' },
            message: "must have required property '" + 'originalName' + "'",
          };
          if (vErrors === null) {
            vErrors = [err4];
          } else {
            vErrors.push(err4);
          }
          errors++;
        }
        if (data0.kind === undefined) {
          const err5 = {
            instancePath: instancePath + '/' + i0,
            schemaPath: '#/items/required',
            keyword: 'required',
            params: { missingProperty: 'kind' },
            message: "must have required property '" + 'kind' + "'",
          };
          if (vErrors === null) {
            vErrors = [err5];
          } else {
            vErrors.push(err5);
          }
          errors++;
        }
        if (data0.mainFilePath === undefined) {
          const err6 = {
            instancePath: instancePath + '/' + i0,
            schemaPath: '#/items/required',
            keyword: 'required',
            params: { missingProperty: 'mainFilePath' },
            message: "must have required property '" + 'mainFilePath' + "'",
          };
          if (vErrors === null) {
            vErrors = [err6];
          } else {
            vErrors.push(err6);
          }
          errors++;
        }
        if (data0.content === undefined) {
          const err7 = {
            instancePath: instancePath + '/' + i0,
            schemaPath: '#/items/required',
            keyword: 'required',
            params: { missingProperty: 'content' },
            message: "must have required property '" + 'content' + "'",
          };
          if (vErrors === null) {
            vErrors = [err7];
          } else {
            vErrors.push(err7);
          }
          errors++;
        }
        if (data0.notes === undefined) {
          const err8 = {
            instancePath: instancePath + '/' + i0,
            schemaPath: '#/items/required',
            keyword: 'required',
            params: { missingProperty: 'notes' },
            message: "must have required property '" + 'notes' + "'",
          };
          if (vErrors === null) {
            vErrors = [err8];
          } else {
            vErrors.push(err8);
          }
          errors++;
        }
        if (data0.savedAt === undefined) {
          const err9 = {
            instancePath: instancePath + '/' + i0,
            schemaPath: '#/items/required',
            keyword: 'required',
            params: { missingProperty: 'savedAt' },
            message: "must have required property '" + 'savedAt' + "'",
          };
          if (vErrors === null) {
            vErrors = [err9];
          } else {
            vErrors.push(err9);
          }
          errors++;
        }
        if (data0.lastLoadedAt === undefined) {
          const err10 = {
            instancePath: instancePath + '/' + i0,
            schemaPath: '#/items/required',
            keyword: 'required',
            params: { missingProperty: 'lastLoadedAt' },
            message: "must have required property '" + 'lastLoadedAt' + "'",
          };
          if (vErrors === null) {
            vErrors = [err10];
          } else {
            vErrors.push(err10);
          }
          errors++;
        }
        if (data0.id !== undefined) {
          let data1 = data0.id;
          if (typeof data1 !== 'string') {
            let dataType0 = typeof data1;
            let coerced0 = undefined;
            if (!(coerced0 !== undefined)) {
              if (dataType0 == 'number' || dataType0 == 'boolean') {
                coerced0 = '' + data1;
              } else if (data1 === null) {
                coerced0 = '';
              } else {
                const err11 = {
                  instancePath: instancePath + '/' + i0 + '/id',
                  schemaPath: '#/items/properties/id/type',
                  keyword: 'type',
                  params: { type: 'string' },
                  message: 'must be string',
                };
                if (vErrors === null) {
                  vErrors = [err11];
                } else {
                  vErrors.push(err11);
                }
                errors++;
              }
            }
            if (coerced0 !== undefined) {
              data1 = coerced0;
              if (data0 !== undefined) {
                data0['id'] = coerced0;
              }
            }
          }
          if (typeof data1 === 'string') {
            if (func2(data1) < 1) {
              const err12 = {
                instancePath: instancePath + '/' + i0 + '/id',
                schemaPath: '#/items/properties/id/minLength',
                keyword: 'minLength',
                params: { limit: 1 },
                message: 'must NOT have fewer than 1 characters',
              };
              if (vErrors === null) {
                vErrors = [err12];
              } else {
                vErrors.push(err12);
              }
              errors++;
            }
          }
        }
        if (data0.schemaVersion !== undefined) {
          let data2 = data0.schemaVersion;
          if (!(typeof data2 == 'number' && isFinite(data2))) {
            let dataType1 = typeof data2;
            let coerced1 = undefined;
            if (!(coerced1 !== undefined)) {
              if (
                dataType1 == 'boolean' ||
                data2 === null ||
                (dataType1 == 'string' && data2 && data2 == +data2)
              ) {
                coerced1 = +data2;
              } else {
                const err13 = {
                  instancePath: instancePath + '/' + i0 + '/schemaVersion',
                  schemaPath: '#/items/properties/schemaVersion/type',
                  keyword: 'type',
                  params: { type: 'number' },
                  message: 'must be number',
                };
                if (vErrors === null) {
                  vErrors = [err13];
                } else {
                  vErrors.push(err13);
                }
                errors++;
              }
            }
            if (coerced1 !== undefined) {
              data2 = coerced1;
              if (data0 !== undefined) {
                data0['schemaVersion'] = coerced1;
              }
            }
          }
          if (typeof data2 == 'number' && isFinite(data2)) {
            if (data2 > 100 || isNaN(data2)) {
              const err14 = {
                instancePath: instancePath + '/' + i0 + '/schemaVersion',
                schemaPath: '#/items/properties/schemaVersion/maximum',
                keyword: 'maximum',
                params: { comparison: '<=', limit: 100 },
                message: 'must be <= 100',
              };
              if (vErrors === null) {
                vErrors = [err14];
              } else {
                vErrors.push(err14);
              }
              errors++;
            }
            if (data2 < 1 || isNaN(data2)) {
              const err15 = {
                instancePath: instancePath + '/' + i0 + '/schemaVersion',
                schemaPath: '#/items/properties/schemaVersion/minimum',
                keyword: 'minimum',
                params: { comparison: '>=', limit: 1 },
                message: 'must be >= 1',
              };
              if (vErrors === null) {
                vErrors = [err15];
              } else {
                vErrors.push(err15);
              }
              errors++;
            }
          }
        }
        if (data0.name !== undefined) {
          let data3 = data0.name;
          if (typeof data3 !== 'string') {
            let dataType2 = typeof data3;
            let coerced2 = undefined;
            if (!(coerced2 !== undefined)) {
              if (dataType2 == 'number' || dataType2 == 'boolean') {
                coerced2 = '' + data3;
              } else if (data3 === null) {
                coerced2 = '';
              } else {
                const err16 = {
                  instancePath: instancePath + '/' + i0 + '/name',
                  schemaPath: '#/items/properties/name/type',
                  keyword: 'type',
                  params: { type: 'string' },
                  message: 'must be string',
                };
                if (vErrors === null) {
                  vErrors = [err16];
                } else {
                  vErrors.push(err16);
                }
                errors++;
              }
            }
            if (coerced2 !== undefined) {
              data3 = coerced2;
              if (data0 !== undefined) {
                data0['name'] = coerced2;
              }
            }
          }
          if (typeof data3 === 'string') {
            if (func2(data3) > 255) {
              const err17 = {
                instancePath: instancePath + '/' + i0 + '/name',
                schemaPath: '#/items/properties/name/maxLength',
                keyword: 'maxLength',
                params: { limit: 255 },
                message: 'must NOT have more than 255 characters',
              };
              if (vErrors === null) {
                vErrors = [err17];
              } else {
                vErrors.push(err17);
              }
              errors++;
            }
            if (func2(data3) < 1) {
              const err18 = {
                instancePath: instancePath + '/' + i0 + '/name',
                schemaPath: '#/items/properties/name/minLength',
                keyword: 'minLength',
                params: { limit: 1 },
                message: 'must NOT have fewer than 1 characters',
              };
              if (vErrors === null) {
                vErrors = [err18];
              } else {
                vErrors.push(err18);
              }
              errors++;
            }
          }
        }
        if (data0.originalName !== undefined) {
          let data4 = data0.originalName;
          if (typeof data4 !== 'string') {
            let dataType3 = typeof data4;
            let coerced3 = undefined;
            if (!(coerced3 !== undefined)) {
              if (dataType3 == 'number' || dataType3 == 'boolean') {
                coerced3 = '' + data4;
              } else if (data4 === null) {
                coerced3 = '';
              } else {
                const err19 = {
                  instancePath: instancePath + '/' + i0 + '/originalName',
                  schemaPath: '#/items/properties/originalName/type',
                  keyword: 'type',
                  params: { type: 'string' },
                  message: 'must be string',
                };
                if (vErrors === null) {
                  vErrors = [err19];
                } else {
                  vErrors.push(err19);
                }
                errors++;
              }
            }
            if (coerced3 !== undefined) {
              data4 = coerced3;
              if (data0 !== undefined) {
                data0['originalName'] = coerced3;
              }
            }
          }
          if (typeof data4 === 'string') {
            if (func2(data4) > 255) {
              const err20 = {
                instancePath: instancePath + '/' + i0 + '/originalName',
                schemaPath: '#/items/properties/originalName/maxLength',
                keyword: 'maxLength',
                params: { limit: 255 },
                message: 'must NOT have more than 255 characters',
              };
              if (vErrors === null) {
                vErrors = [err20];
              } else {
                vErrors.push(err20);
              }
              errors++;
            }
            if (func2(data4) < 1) {
              const err21 = {
                instancePath: instancePath + '/' + i0 + '/originalName',
                schemaPath: '#/items/properties/originalName/minLength',
                keyword: 'minLength',
                params: { limit: 1 },
                message: 'must NOT have fewer than 1 characters',
              };
              if (vErrors === null) {
                vErrors = [err21];
              } else {
                vErrors.push(err21);
              }
              errors++;
            }
          }
        }
        if (data0.kind !== undefined) {
          let data5 = data0.kind;
          if (typeof data5 !== 'string') {
            let dataType4 = typeof data5;
            let coerced4 = undefined;
            if (!(coerced4 !== undefined)) {
              if (dataType4 == 'number' || dataType4 == 'boolean') {
                coerced4 = '' + data5;
              } else if (data5 === null) {
                coerced4 = '';
              } else {
                const err22 = {
                  instancePath: instancePath + '/' + i0 + '/kind',
                  schemaPath: '#/items/properties/kind/type',
                  keyword: 'type',
                  params: { type: 'string' },
                  message: 'must be string',
                };
                if (vErrors === null) {
                  vErrors = [err22];
                } else {
                  vErrors.push(err22);
                }
                errors++;
              }
            }
            if (coerced4 !== undefined) {
              data5 = coerced4;
              if (data0 !== undefined) {
                data0['kind'] = coerced4;
              }
            }
          }
          if (
            !(data5 === 'scad' || data5 === 'zip' || data5 === 'folder-link')
          ) {
            const err23 = {
              instancePath: instancePath + '/' + i0 + '/kind',
              schemaPath: '#/items/properties/kind/enum',
              keyword: 'enum',
              params: { allowedValues: schema18.items.properties.kind.enum },
              message: 'must be equal to one of the allowed values',
            };
            if (vErrors === null) {
              vErrors = [err23];
            } else {
              vErrors.push(err23);
            }
            errors++;
          }
        }
        if (data0.mainFilePath !== undefined) {
          let data6 = data0.mainFilePath;
          if (typeof data6 !== 'string') {
            let dataType5 = typeof data6;
            let coerced5 = undefined;
            if (!(coerced5 !== undefined)) {
              if (dataType5 == 'number' || dataType5 == 'boolean') {
                coerced5 = '' + data6;
              } else if (data6 === null) {
                coerced5 = '';
              } else {
                const err24 = {
                  instancePath: instancePath + '/' + i0 + '/mainFilePath',
                  schemaPath: '#/items/properties/mainFilePath/type',
                  keyword: 'type',
                  params: { type: 'string' },
                  message: 'must be string',
                };
                if (vErrors === null) {
                  vErrors = [err24];
                } else {
                  vErrors.push(err24);
                }
                errors++;
              }
            }
            if (coerced5 !== undefined) {
              data6 = coerced5;
              if (data0 !== undefined) {
                data0['mainFilePath'] = coerced5;
              }
            }
          }
          if (typeof data6 === 'string') {
            if (func2(data6) > 500) {
              const err25 = {
                instancePath: instancePath + '/' + i0 + '/mainFilePath',
                schemaPath: '#/items/properties/mainFilePath/maxLength',
                keyword: 'maxLength',
                params: { limit: 500 },
                message: 'must NOT have more than 500 characters',
              };
              if (vErrors === null) {
                vErrors = [err25];
              } else {
                vErrors.push(err25);
              }
              errors++;
            }
            if (func2(data6) < 1) {
              const err26 = {
                instancePath: instancePath + '/' + i0 + '/mainFilePath',
                schemaPath: '#/items/properties/mainFilePath/minLength',
                keyword: 'minLength',
                params: { limit: 1 },
                message: 'must NOT have fewer than 1 characters',
              };
              if (vErrors === null) {
                vErrors = [err26];
              } else {
                vErrors.push(err26);
              }
              errors++;
            }
          }
        }
        if (data0.content !== undefined) {
          let data7 = data0.content;
          if (typeof data7 !== 'string') {
            let dataType6 = typeof data7;
            let coerced6 = undefined;
            if (!(coerced6 !== undefined)) {
              if (dataType6 == 'number' || dataType6 == 'boolean') {
                coerced6 = '' + data7;
              } else if (data7 === null) {
                coerced6 = '';
              } else {
                const err27 = {
                  instancePath: instancePath + '/' + i0 + '/content',
                  schemaPath: '#/items/properties/content/type',
                  keyword: 'type',
                  params: { type: 'string' },
                  message: 'must be string',
                };
                if (vErrors === null) {
                  vErrors = [err27];
                } else {
                  vErrors.push(err27);
                }
                errors++;
              }
            }
            if (coerced6 !== undefined) {
              data7 = coerced6;
              if (data0 !== undefined) {
                data0['content'] = coerced6;
              }
            }
          }
          if (typeof data7 === 'string') {
            if (func2(data7) > 5242880) {
              const err28 = {
                instancePath: instancePath + '/' + i0 + '/content',
                schemaPath: '#/items/properties/content/maxLength',
                keyword: 'maxLength',
                params: { limit: 5242880 },
                message: 'must NOT have more than 5242880 characters',
              };
              if (vErrors === null) {
                vErrors = [err28];
              } else {
                vErrors.push(err28);
              }
              errors++;
            }
          }
        }
        let data8 = data0.projectFiles;
        if (typeof data8 !== 'string' && data8 !== null) {
          let dataType7 = typeof data8;
          let coerced7 = undefined;
          if (!(coerced7 !== undefined)) {
            if (dataType7 == 'number' || dataType7 == 'boolean') {
              coerced7 = '' + data8;
            } else if (data8 === null) {
              coerced7 = '';
            } else if (data8 === '' || data8 === 0 || data8 === false) {
              coerced7 = null;
            } else {
              const err29 = {
                instancePath: instancePath + '/' + i0 + '/projectFiles',
                schemaPath: '#/items/properties/projectFiles/type',
                keyword: 'type',
                params: { type: schema18.items.properties.projectFiles.type },
                message: 'must be string,null',
              };
              if (vErrors === null) {
                vErrors = [err29];
              } else {
                vErrors.push(err29);
              }
              errors++;
            }
          }
          if (coerced7 !== undefined) {
            data8 = coerced7;
            if (data0 !== undefined) {
              data0['projectFiles'] = coerced7;
            }
          }
        }
        let data9 = data0.folderRef;
        if (typeof data9 !== 'string' && data9 !== null) {
          let dataType8 = typeof data9;
          let coerced8 = undefined;
          if (!(coerced8 !== undefined)) {
            if (dataType8 == 'number' || dataType8 == 'boolean') {
              coerced8 = '' + data9;
            } else if (data9 === null) {
              coerced8 = '';
            } else if (data9 === '' || data9 === 0 || data9 === false) {
              coerced8 = null;
            } else {
              const err30 = {
                instancePath: instancePath + '/' + i0 + '/folderRef',
                schemaPath: '#/items/properties/folderRef/type',
                keyword: 'type',
                params: { type: schema18.items.properties.folderRef.type },
                message: 'must be string,null',
              };
              if (vErrors === null) {
                vErrors = [err30];
              } else {
                vErrors.push(err30);
              }
              errors++;
            }
          }
          if (coerced8 !== undefined) {
            data9 = coerced8;
            if (data0 !== undefined) {
              data0['folderRef'] = coerced8;
            }
          }
        }
        let data10 = data0.fileSummary;
        if (
          !(data10 && typeof data10 == 'object' && !Array.isArray(data10)) &&
          data10 !== null
        ) {
          let coerced9 = undefined;
          if (!(coerced9 !== undefined)) {
            if (data10 === '' || data10 === 0 || data10 === false) {
              coerced9 = null;
            } else {
              const err31 = {
                instancePath: instancePath + '/' + i0 + '/fileSummary',
                schemaPath: '#/items/properties/fileSummary/type',
                keyword: 'type',
                params: { type: schema18.items.properties.fileSummary.type },
                message: 'must be object,null',
              };
              if (vErrors === null) {
                vErrors = [err31];
              } else {
                vErrors.push(err31);
              }
              errors++;
            }
          }
          if (coerced9 !== undefined) {
            data10 = coerced9;
            if (data0 !== undefined) {
              data0['fileSummary'] = coerced9;
            }
          }
        }
        if (data10 && typeof data10 == 'object' && !Array.isArray(data10)) {
          if (data10.fileCount !== undefined) {
            let data11 = data10.fileCount;
            if (!(typeof data11 == 'number' && isFinite(data11))) {
              let dataType10 = typeof data11;
              let coerced10 = undefined;
              if (!(coerced10 !== undefined)) {
                if (
                  dataType10 == 'boolean' ||
                  data11 === null ||
                  (dataType10 == 'string' && data11 && data11 == +data11)
                ) {
                  coerced10 = +data11;
                } else {
                  const err32 = {
                    instancePath:
                      instancePath + '/' + i0 + '/fileSummary/fileCount',
                    schemaPath:
                      '#/items/properties/fileSummary/properties/fileCount/type',
                    keyword: 'type',
                    params: { type: 'number' },
                    message: 'must be number',
                  };
                  if (vErrors === null) {
                    vErrors = [err32];
                  } else {
                    vErrors.push(err32);
                  }
                  errors++;
                }
              }
              if (coerced10 !== undefined) {
                data11 = coerced10;
                if (data10 !== undefined) {
                  data10['fileCount'] = coerced10;
                }
              }
            }
            if (typeof data11 == 'number' && isFinite(data11)) {
              if (data11 < 0 || isNaN(data11)) {
                const err33 = {
                  instancePath:
                    instancePath + '/' + i0 + '/fileSummary/fileCount',
                  schemaPath:
                    '#/items/properties/fileSummary/properties/fileCount/minimum',
                  keyword: 'minimum',
                  params: { comparison: '>=', limit: 0 },
                  message: 'must be >= 0',
                };
                if (vErrors === null) {
                  vErrors = [err33];
                } else {
                  vErrors.push(err33);
                }
                errors++;
              }
            }
          }
          if (data10.totalBytes !== undefined) {
            let data12 = data10.totalBytes;
            if (!(typeof data12 == 'number' && isFinite(data12))) {
              let dataType11 = typeof data12;
              let coerced11 = undefined;
              if (!(coerced11 !== undefined)) {
                if (
                  dataType11 == 'boolean' ||
                  data12 === null ||
                  (dataType11 == 'string' && data12 && data12 == +data12)
                ) {
                  coerced11 = +data12;
                } else {
                  const err34 = {
                    instancePath:
                      instancePath + '/' + i0 + '/fileSummary/totalBytes',
                    schemaPath:
                      '#/items/properties/fileSummary/properties/totalBytes/type',
                    keyword: 'type',
                    params: { type: 'number' },
                    message: 'must be number',
                  };
                  if (vErrors === null) {
                    vErrors = [err34];
                  } else {
                    vErrors.push(err34);
                  }
                  errors++;
                }
              }
              if (coerced11 !== undefined) {
                data12 = coerced11;
                if (data10 !== undefined) {
                  data10['totalBytes'] = coerced11;
                }
              }
            }
            if (typeof data12 == 'number' && isFinite(data12)) {
              if (data12 < 0 || isNaN(data12)) {
                const err35 = {
                  instancePath:
                    instancePath + '/' + i0 + '/fileSummary/totalBytes',
                  schemaPath:
                    '#/items/properties/fileSummary/properties/totalBytes/minimum',
                  keyword: 'minimum',
                  params: { comparison: '>=', limit: 0 },
                  message: 'must be >= 0',
                };
                if (vErrors === null) {
                  vErrors = [err35];
                } else {
                  vErrors.push(err35);
                }
                errors++;
              }
            }
          }
        }
        let data13 = data0.folderId;
        if (typeof data13 !== 'string' && data13 !== null) {
          let dataType12 = typeof data13;
          let coerced12 = undefined;
          if (!(coerced12 !== undefined)) {
            if (dataType12 == 'number' || dataType12 == 'boolean') {
              coerced12 = '' + data13;
            } else if (data13 === null) {
              coerced12 = '';
            } else if (data13 === '' || data13 === 0 || data13 === false) {
              coerced12 = null;
            } else {
              const err36 = {
                instancePath: instancePath + '/' + i0 + '/folderId',
                schemaPath: '#/items/properties/folderId/type',
                keyword: 'type',
                params: { type: schema18.items.properties.folderId.type },
                message: 'must be string,null',
              };
              if (vErrors === null) {
                vErrors = [err36];
              } else {
                vErrors.push(err36);
              }
              errors++;
            }
          }
          if (coerced12 !== undefined) {
            data13 = coerced12;
            if (data0 !== undefined) {
              data0['folderId'] = coerced12;
            }
          }
        }
        let data14 = data0.overlayFiles;
        if (!(data14 && typeof data14 == 'object' && !Array.isArray(data14))) {
          const err37 = {
            instancePath: instancePath + '/' + i0 + '/overlayFiles',
            schemaPath: '#/items/properties/overlayFiles/type',
            keyword: 'type',
            params: { type: 'object' },
            message: 'must be object',
          };
          if (vErrors === null) {
            vErrors = [err37];
          } else {
            vErrors.push(err37);
          }
          errors++;
        }
        if (!Array.isArray(data0.presets)) {
          const err38 = {
            instancePath: instancePath + '/' + i0 + '/presets',
            schemaPath: '#/items/properties/presets/type',
            keyword: 'type',
            params: { type: 'array' },
            message: 'must be array',
          };
          if (vErrors === null) {
            vErrors = [err38];
          } else {
            vErrors.push(err38);
          }
          errors++;
        }
        let data16 = data0.notes;
        if (typeof data16 !== 'string') {
          let dataType13 = typeof data16;
          let coerced13 = undefined;
          if (!(coerced13 !== undefined)) {
            if (dataType13 == 'number' || dataType13 == 'boolean') {
              coerced13 = '' + data16;
            } else if (data16 === null) {
              coerced13 = '';
            } else {
              const err39 = {
                instancePath: instancePath + '/' + i0 + '/notes',
                schemaPath: '#/items/properties/notes/type',
                keyword: 'type',
                params: { type: 'string' },
                message: 'must be string',
              };
              if (vErrors === null) {
                vErrors = [err39];
              } else {
                vErrors.push(err39);
              }
              errors++;
            }
          }
          if (coerced13 !== undefined) {
            data16 = coerced13;
            if (data0 !== undefined) {
              data0['notes'] = coerced13;
            }
          }
        }
        if (typeof data16 === 'string') {
          if (func2(data16) > 5000) {
            const err40 = {
              instancePath: instancePath + '/' + i0 + '/notes',
              schemaPath: '#/items/properties/notes/maxLength',
              keyword: 'maxLength',
              params: { limit: 5000 },
              message: 'must NOT have more than 5000 characters',
            };
            if (vErrors === null) {
              vErrors = [err40];
            } else {
              vErrors.push(err40);
            }
            errors++;
          }
        }
        let data17 = data0.forkedFrom;
        if (
          !(data17 && typeof data17 == 'object' && !Array.isArray(data17)) &&
          data17 !== null
        ) {
          let coerced14 = undefined;
          if (!(coerced14 !== undefined)) {
            if (data17 === '' || data17 === 0 || data17 === false) {
              coerced14 = null;
            } else {
              const err41 = {
                instancePath: instancePath + '/' + i0 + '/forkedFrom',
                schemaPath: '#/items/properties/forkedFrom/type',
                keyword: 'type',
                params: { type: schema18.items.properties.forkedFrom.type },
                message: 'must be object,null',
              };
              if (vErrors === null) {
                vErrors = [err41];
              } else {
                vErrors.push(err41);
              }
              errors++;
            }
          }
          if (coerced14 !== undefined) {
            data17 = coerced14;
            if (data0 !== undefined) {
              data0['forkedFrom'] = coerced14;
            }
          }
        }
        let data18 = data0.uiPreferences;
        if (
          !(data18 && typeof data18 == 'object' && !Array.isArray(data18)) &&
          data18 !== null
        ) {
          let coerced15 = undefined;
          if (!(coerced15 !== undefined)) {
            if (data18 === '' || data18 === 0 || data18 === false) {
              coerced15 = null;
            } else {
              const err42 = {
                instancePath: instancePath + '/' + i0 + '/uiPreferences',
                schemaPath: '#/items/properties/uiPreferences/type',
                keyword: 'type',
                params: { type: schema18.items.properties.uiPreferences.type },
                message: 'must be object,null',
              };
              if (vErrors === null) {
                vErrors = [err42];
              } else {
                vErrors.push(err42);
              }
              errors++;
            }
          }
          if (coerced15 !== undefined) {
            data18 = coerced15;
            if (data0 !== undefined) {
              data0['uiPreferences'] = coerced15;
            }
          }
        }
        let data19 = data0.sourceExampleKey;
        if (typeof data19 !== 'string' && data19 !== null) {
          let dataType16 = typeof data19;
          let coerced16 = undefined;
          if (!(coerced16 !== undefined)) {
            if (dataType16 == 'number' || dataType16 == 'boolean') {
              coerced16 = '' + data19;
            } else if (data19 === null) {
              coerced16 = '';
            } else if (data19 === '' || data19 === 0 || data19 === false) {
              coerced16 = null;
            } else {
              const err43 = {
                instancePath: instancePath + '/' + i0 + '/sourceExampleKey',
                schemaPath: '#/items/properties/sourceExampleKey/type',
                keyword: 'type',
                params: {
                  type: schema18.items.properties.sourceExampleKey.type,
                },
                message: 'must be string,null',
              };
              if (vErrors === null) {
                vErrors = [err43];
              } else {
                vErrors.push(err43);
              }
              errors++;
            }
          }
          if (coerced16 !== undefined) {
            data19 = coerced16;
            if (data0 !== undefined) {
              data0['sourceExampleKey'] = coerced16;
            }
          }
        }
        if (data0.savedAt !== undefined) {
          let data20 = data0.savedAt;
          if (!(typeof data20 == 'number' && isFinite(data20))) {
            let dataType17 = typeof data20;
            let coerced17 = undefined;
            if (!(coerced17 !== undefined)) {
              if (
                dataType17 == 'boolean' ||
                data20 === null ||
                (dataType17 == 'string' && data20 && data20 == +data20)
              ) {
                coerced17 = +data20;
              } else {
                const err44 = {
                  instancePath: instancePath + '/' + i0 + '/savedAt',
                  schemaPath: '#/items/properties/savedAt/type',
                  keyword: 'type',
                  params: { type: 'number' },
                  message: 'must be number',
                };
                if (vErrors === null) {
                  vErrors = [err44];
                } else {
                  vErrors.push(err44);
                }
                errors++;
              }
            }
            if (coerced17 !== undefined) {
              data20 = coerced17;
              if (data0 !== undefined) {
                data0['savedAt'] = coerced17;
              }
            }
          }
          if (typeof data20 == 'number' && isFinite(data20)) {
            if (data20 < 0 || isNaN(data20)) {
              const err45 = {
                instancePath: instancePath + '/' + i0 + '/savedAt',
                schemaPath: '#/items/properties/savedAt/minimum',
                keyword: 'minimum',
                params: { comparison: '>=', limit: 0 },
                message: 'must be >= 0',
              };
              if (vErrors === null) {
                vErrors = [err45];
              } else {
                vErrors.push(err45);
              }
              errors++;
            }
          }
        }
        if (data0.lastLoadedAt !== undefined) {
          let data21 = data0.lastLoadedAt;
          if (!(typeof data21 == 'number' && isFinite(data21))) {
            let dataType18 = typeof data21;
            let coerced18 = undefined;
            if (!(coerced18 !== undefined)) {
              if (
                dataType18 == 'boolean' ||
                data21 === null ||
                (dataType18 == 'string' && data21 && data21 == +data21)
              ) {
                coerced18 = +data21;
              } else {
                const err46 = {
                  instancePath: instancePath + '/' + i0 + '/lastLoadedAt',
                  schemaPath: '#/items/properties/lastLoadedAt/type',
                  keyword: 'type',
                  params: { type: 'number' },
                  message: 'must be number',
                };
                if (vErrors === null) {
                  vErrors = [err46];
                } else {
                  vErrors.push(err46);
                }
                errors++;
              }
            }
            if (coerced18 !== undefined) {
              data21 = coerced18;
              if (data0 !== undefined) {
                data0['lastLoadedAt'] = coerced18;
              }
            }
          }
          if (typeof data21 == 'number' && isFinite(data21)) {
            if (data21 < 0 || isNaN(data21)) {
              const err47 = {
                instancePath: instancePath + '/' + i0 + '/lastLoadedAt',
                schemaPath: '#/items/properties/lastLoadedAt/minimum',
                keyword: 'minimum',
                params: { comparison: '>=', limit: 0 },
                message: 'must be >= 0',
              };
              if (vErrors === null) {
                vErrors = [err47];
              } else {
                vErrors.push(err47);
              }
              errors++;
            }
          }
        }
      } else {
        const err48 = {
          instancePath: instancePath + '/' + i0,
          schemaPath: '#/items/type',
          keyword: 'type',
          params: { type: 'object' },
          message: 'must be object',
        };
        if (vErrors === null) {
          vErrors = [err48];
        } else {
          vErrors.push(err48);
        }
        errors++;
      }
    }
  } else {
    const err49 = {
      instancePath,
      schemaPath: '#/type',
      keyword: 'type',
      params: { type: 'array' },
      message: 'must be array',
    };
    if (vErrors === null) {
      vErrors = [err49];
    } else {
      vErrors.push(err49);
    }
    errors++;
  }
  validate17.errors = vErrors;
  return errors === 0;
}
